import { dehydrate, QueryClient } from "react-query";

export const reactQueryConfig = {
  defaultOptions: {
    queries: {
      retryOnMount: false,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  },
};

export const dehydrateData = (queryClient: QueryClient) => {
  return {
    dehydratedState: dehydrate(queryClient)
  }
}